"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconFacebookMessenger = Experimental__IconFacebookMessenger;
exports.IconFacebookMessenger = IconFacebookMessenger;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconFacebookMessenger/index.tsx)
 */
function IconFacebookMessenger(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M0 7.76C0 3.301 3.493 0 8 0s8 3.301 8 7.76-3.493 7.76-8 7.76c-.81 0-1.586-.107-2.316-.307a.639.639 0 0 0-.427.03l-1.588.702a.64.64 0 0 1-.898-.566l-.044-1.423a.639.639 0 0 0-.215-.456C.956 12.108 0 10.092 0 7.76zm5.546-1.459-2.35 3.728c-.225.358.214.761.551.506l2.525-1.916a.48.48 0 0 1 .578-.002l1.869 1.402a1.2 1.2 0 0 0 1.735-.32l2.35-3.728c.226-.358-.214-.761-.551-.506L9.729 7.381a.48.48 0 0 1-.579.002L7.281 5.98a1.2 1.2 0 0 0-1.735.32z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M2.625 11.953C2.625 6.728 6.719 2.86 12 2.86s9.375 3.869 9.375 9.094-4.094 9.094-9.375 9.094c-.949 0-1.859-.125-2.714-.36a.748.748 0 0 0-.5.036l-1.861.822a.75.75 0 0 1-1.053-.664l-.05-1.667a.749.749 0 0 0-.253-.535c-1.824-1.631-2.944-3.993-2.944-6.726zm6.5-1.71-2.755 4.37c-.264.419.251.891.646.592l2.958-2.245a.562.562 0 0 1 .678-.002l2.19 1.643c.658.492 1.596.32 2.034-.376l2.754-4.369c.264-.42-.252-.892-.646-.592l-2.958 2.245a.562.562 0 0 1-.678.002l-2.19-1.643a1.406 1.406 0 0 0-2.034.375z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconFacebookMessenger is deprecated and will be archived soon. Use IconFacebookMessenger instead.
 */
function Experimental__IconFacebookMessenger(props) {
  return /*#__PURE__*/_react["default"].createElement(IconFacebookMessenger, props);
}